<button class="btn btn-home" (click)="goToMainPage()">Main page</button>